<template>
    <form class="filterform" @submit.prevent="applyFilter()">
        <div class="row">
            <div class="col-sm-4 col-3">
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('incomingDocFilter.documentNo')}}</label>
                    <div class="col-sm-8">
                        <input type="text" name="documentId" @input="checkInput('documentId',$event)" id="documentId" v-model="data.documentId" class="form-control form-control-sm">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('incomingDoc.filterEditor.filterTypes.sender')}}</label>
                    <div class="col-sm-8">
                        <input type="text" name="sender" @input="checkInput('sender',$event)" id="sender" v-model="data.sender" class="form-control form-control-sm">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('filePreview.eypPreview.subject')}}</label>
                    <div class="col-sm-8">
                        <input type="text" name="name" @input="checkInput('name',$event)" id="name" v-model="data.name" class="form-control form-control-sm">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('incomingDocFilter.createDate')}}</label>
                    <div class="col-sm-8">
                        <div class="input-group input-group-sm">
                            <date-input v-model="data.FirstDate" :max="max" class="form-control" :placeholder="translate('first')" />
                        </div>
                        <div class="input-group input-group-sm mb-3">
                            <date-input v-model="data.LastDate" :max="max" class="form-control" :placeholder="translate('last')" />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('incomingDocFilter.docType')}}</label>
                    <div class="col-sm-8">
                        <select name="messageType" id="messageType" class="form-control" v-model="data.messageType">
                            <option value="Kep">KEP</option>
                            <option value="Uets">UETS</option>
                            <option value="Pdf">PDF</option>
                            <option value="Xml">XML</option>
                            <option value="Ftp">FTP</option>
                            <option value="Email">Email</option>
                            <option value="Other">Diğer</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('incomingDocFilter.readStatus')}}</label>
                    <div class="col-sm-8">
                        <select name="isRead" id="isRead" class="form-control" v-model="data.isRead">
                            <option value="0">{{translate('incomingDocFilter.read')}}</option>
                            <option value="1">{{translate('incomingDocFilter.dontRead')}}</option>
                            <option value="2">{{translate('incomingDocFilter.all')}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label">{{translate('incomingDocFilter.archiveStatus')}}</label>
                    <div class="col-sm-8">
                        <select name="isArchived" id="isArchived" class="form-control" v-model="data.isArchived">
                            <option value="0">{{translate('incomingDocFilter.archived')}}</option>
                            <option value="1">{{translate('incomingDocFilter.dontArchived')}}</option>
                            <option value="2">{{translate('incomingDocFilter.all')}}</option>
                        </select>
                    </div>
                </div>                
            </div>
            <div class="col-sm-8 col-9">
                <div class="row">
                    <div class="col-4">
                        <label>{{translate('login.user')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.UserIds" :list="getDraftUsers()" :get-text="x => x.FullName" :get-value="x => x.Id"></select-multiple>
                    </div>
                    <div class="col-4">
                        <label>{{translate('approvalAuthorityEditorUser.department')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.DepartmentIds" :list="departments"></select-multiple>
                    </div>
                    <div class="col-4">
                        <label>{{translate('incomingDocFilter.filter')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.FilterIds" :list="filters" ></select-multiple>
                    </div>
                    <div class="col-4" style="margin-top: 10px;">
                        <label>{{translate('incomingDocFilter.incomingDocReceiver')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.IncomingChannelIds" :list="incomingChannel"></select-multiple>
                    </div>
                    <div class="col-4" style="margin-top: 10px;">
                        <label>{{translate('incomingDoc.filterEditor.categories')}}</label>
                        <select-multiple :autocomplete="true" v-model="data.CategoryIds" :list="categories">
                            <template slot-scope="{ item }">
                                <div>
                                    <small class="float-right badge">{{item.Type | documentType }}</small>
                                {{item.Name}}
                                </div>
                            </template>
                        </select-multiple>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="col-auto text-right" style="padding-top:30px;">
                            <button type="button" class="btn btn-outline-secondary" @click="cancel" style="margin-right:8px;">{{translate('cancel')}}</button>
                            <button type="submit" class="btn btn-success" accesskey="t" v-html="translate('applyFilters')"></button>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- <code>{{data}}</code> -->
        </div>
    </form>
</template>
<script>
import selectMultiple from './SelectMultiple.vue'
import DateInput from './DateInput.vue'

export default {
    components: {
        selectMultiple,
        DateInput
    },
    data(){
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const maxDate = new Date(today)
        return {
            data: {},
            draftUsers: null,
            max: maxDate,
        }
    },
    props: {
        departments: {
            type: Array,
            required: true
        },
        users: {
            type: Array,
            required: true,
        },
        filter: {
            type: Object,
            required: true
        },
        filters: {
            type: Array,
            required: true
        },
        incomingChannel: {
            type: Array,
            required: true
        },
        categories:{
            type: Array,
            required: true

        }

    },
    created(){
        this.data = JSON.parse(JSON.stringify(this.filter));
        console.log('FilterForm Created');
        console.log(this.data)
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        applyFilter(){
            if(this.data.LastDate != null){
                var lastdate = new Date(this.data.LastDate);
                lastdate.setHours(23)
                lastdate.setMinutes(59)
                lastdate.setSeconds(59)
                console.log(lastdate);
                this.data.LastDate = lastdate;
            }
            this.$emit('apply', this.data);
        },
        cancel(){
            this.$emit('cancel');
        },
        getDraftUsers(){
            if(this.draftUsers == null || this.draftUsers.length == 0)
            {
                if(this.users != null && this.users.length > 0)
                {
                    this.draftUsers = this.users.filter(x => 
                        x.Authorities.indexOf("Draft") >= 0 || 
                        x.Authorities.indexOf("Admin") >= 0
                    );
                }
            }

            return this.draftUsers;
        }
    },
}
</script>
<style scoped>

</style>